/**
 * Configuration constants for vehicle comparison feature
 */
export const COMPARISON_CONFIG = {
  /**
   * Minimum number of comparison mode images required per vehicle to enable comparison
   */
  MIN_IMAGES_REQUIRED: 3,

  /**
   * Z-index for comparison banner overlay
   */
  BANNER_Z_INDEX: 100,

  /**
   * Transition delay for vehicle swap operations (milliseconds)
   */
  SWAP_TRANSITION_DELAY_MS: 50,
} as const;
